/**
 * @generated SignedSource<<61d7f83446e05648104dc06231e4083d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ElementTypeV2 = "clozeText" | "file" | "multipleChoice" | "order" | "podcast" | "randomMultipleChoice" | "text" | "video" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ELearningContentEditor_TreeNodeFragment$data = {
  readonly id: string;
  readonly typeDefinition: {
    readonly elements?: ReadonlyArray<{
      readonly elementType: ElementTypeV2;
      readonly id: string;
      readonly title: string;
      readonly " $fragmentSpreads": FragmentRefs<"ElementForm_ElementV2Fragment">;
    }>;
  };
  readonly " $fragmentType": "ELearningContentEditor_TreeNodeFragment";
};
export type ELearningContentEditor_TreeNodeFragment$key = {
  readonly " $data"?: ELearningContentEditor_TreeNodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ELearningContentEditor_TreeNodeFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ELearningContentEditor_TreeNodeFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "typeDefinition",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "elements",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "elementType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ElementForm_ElementV2Fragment"
                }
              ],
              "storageKey": null
            }
          ],
          "type": "ELearningContentTypeDefinition",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TreeNode",
  "abstractKey": null
};
})();

(node as any).hash = "16c350d215ffb0c09130d2f592d9c030";

export default node;
